import { useCmsList } from '../hooks/useCms';
import { useEducationData } from '../hooks/useEducationData';
import { BusinessSection, EducationFAQ, EducationFinalCTA, EducationIntro, EducationPrice, InstructorSpotlight, Outcomes, ProblemStatement, Roadmap, StudentCase } from '../components/EducationSections';
import HomeHero from '../components/HomeHero';
import SalonTransition from '../components/SalonTransition';

export default function HomePage({ page }) {
  const content = useEducationData();
  const services = useCmsList('services', { sort: 'sort_order', order: 'asc', limit: 12 });
  const section = content.homeSection;
  return <>
    <HomeHero page={page} />
    <EducationIntro section={section('intro')} />
    <Outcomes section={section('outcomes')} items={content.outcomes} />
    <ProblemStatement section={section('problem')} />
    <Roadmap section={section('roadmap')} items={content.roadmap} />
    <BusinessSection section={section('business')} items={content.business} />
    <StudentCase section={section('case')} story={content.story} />
    <EducationPrice section={section('training_price')} item={content.coursePrice} />
    <SalonTransition section={section('salon')} services={services.items} />
    <InstructorSpotlight section={section('teacher')} instructor={content.teacher} intro={page.body} />
    <EducationFAQ section={section('faq')} items={content.faq} limit={6} />
    <EducationFinalCTA section={section('final')} />
  </>;
}
